import Vue from 'vue';
import App from './App.vue';
import store from './store';
import plugins from './plugins';
import VueScrollTo from 'vue-scrollto';

import './assets/scss/style.scss';

Vue.use(VueScrollTo, {
  container: 'body',
  duration: 500,
  easing: 'ease',
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true,
});

Vue.config.productionTip = false;

Vue.use(plugins);

new Vue({
  store,
  render: (h) => h(App),
  beforeCreate() {
    // Check if 'lang' parameter is present in the URL
    const urlParams = new URLSearchParams(window.location.search);
    const langFromUrl = urlParams.get('lang');

    // If 'lang' parameter is 'en', set the lang in the store to 'en'
    if (langFromUrl) {
      const lang = langFromUrl.toLowerCase();
      if (lang === 'en') {
        this.$store.commit('setLang', 'en');
      } else if (lang === 'sk') {
        this.$store.commit('setLang', 'sk');
      } else if (lang === 'pl') {
        this.$store.commit('setLang', 'pl');
      }
    }

  },
}).$mount('#app');
